"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalizationComponent = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var i18n_1 = __importDefault(require("../../i18n"));
var utils_1 = require("../../utils");
var lang_1 = require("../../const/lang");
var GlobalizationComponent = function (_a) {
    var _b = _a.langList, langList = _b === void 0 ? [] : _b, _c = _a.triggerType, triggerType = _c === void 0 ? "hover" : _c, onChange = _a.onChange;
    var _d = (0, react_1.useState)(""), openedLabel = _d[0], setOpenedLabel = _d[1];
    var earthRef = (0, react_1.useRef)(null);
    var _e = (0, react_1.useState)(null), menuPos = _e[0], setMenuPos = _e[1];
    var _f = (0, react_1.useState)(false), visible = _f[0], setVisible = _f[1];
    var _g = (0, react_1.useState)({ label: "", value: "", alias: "" }), currentLocale = _g[0], setCurrentLocale = _g[1];
    var usedLocaleList = (0, react_1.useState)(langList.length
        ? lang_1.langList.filter(function (item) { return langList.includes(item.value); })
        : lang_1.defaultLangList)[0];
    var onSelectLocale = function (value) {
        i18n_1.default.setLang(value);
        var parsedLang = lang_1.langList.find(function (ele) { return (0, utils_1.formatLocale)(value) === ele.value; });
        if (parsedLang) {
            setCurrentLocale(parsedLang);
        }
        if (onChange) {
            onChange(value);
        }
    };
    var bodyClickEvent = (0, react_1.useCallback)(function () {
        setTimeout(function () {
            setOpenedLabel("");
            setVisible(false);
        }, 10);
        document.body.removeEventListener("click", bodyClickEvent);
    }, []);
    var handleOpen = function () {
        if (!visible) {
            setOpenedLabel("locale");
            setVisible(true);
            setTimeout(function () {
                document.body.addEventListener("click", bodyClickEvent);
            });
        }
    };
    // 获取当前元素位置，好渲染下拉菜单
    var getCoords = function (ref) {
        var _a;
        var box = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (box) {
            return {
                left: box.left,
                top: box.top + box.height,
                width: box.width,
            };
        }
        return null;
    };
    var renderOptions = function (_a) {
        var _b;
        var type = _a.type, ref = _a.ref, dataSource = _a.dataSource;
        var box = (_b = ref.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        var renderOption = function () {
            var onClick = function (value) {
                if (type === "locale") {
                    onSelectLocale(value);
                }
            };
            return dataSource.map(function (ele) {
                return (react_1.default.createElement("li", { style: {
                        display: "flex",
                        padding: "0 20px",
                        lineHeight: "36px",
                        fontSize: 12,
                        cursor: "pointer",
                        minWidth: 80,
                        color: "#3a3a3a",
                    }, key: ele.value, onClick: function () { return onClick(ele.value); }, onMouseEnter: function (e) {
                        var self = e.target;
                        self.style.backgroundColor = "#f2f3f7";
                        self.style.color = "#284cc0";
                    }, onMouseOut: function (e) {
                        var self = e.target;
                        self.style.backgroundColor = "transparent";
                        self.style.color = "#3a3a3a";
                    }, value: ele.value }, ele.label));
            });
        };
        return (react_1.default.createElement(react_1.default.Fragment, null, (0, react_dom_1.createPortal)(react_1.default.createElement("ul", { className: "panda-i18n-switcher ".concat(openedLabel === type ? "show" : "hide"), id: type, style: openedLabel === type
                ? __assign({ margin: "6px 0 0", padding: "6px 0", overflowY: "auto", backgroundColor: "#fff", borderRadius: 3, position: "absolute", zIndex: 10000, display: "block", border: "1px solid #dcdee3", boxShadow: "0 2px 24px 0 rgba(207, 209, 216, 0.66)" }, (box
                    ? {
                        left: "".concat(box.left, "px"),
                        top: "".concat(box.top + box.height, "px"),
                    }
                    : {})) : {
                display: "none",
            } }, renderOption()), document.body)));
    };
    (0, react_1.useEffect)(function () {
        var lang = i18n_1.default.getLang();
        var parsedLang = lang_1.langList.find(function (ele) { return (0, utils_1.formatLocale)(lang) === ele.value; });
        if (parsedLang) {
            setCurrentLocale(parsedLang);
        }
    }, []);
    (0, react_1.useEffect)(function () {
        if (!visible)
            return;
        setMenuPos(getCoords(earthRef));
    }, [visible]);
    var eventProps = triggerType === "click"
        ? {
            onClick: handleOpen,
            onMouseEnter: function () {
                earthRef.current.style.backgroundColor = "rgba(212, 219, 242, 0.5)";
            },
        }
        : {
            onMouseEnter: function () {
                handleOpen();
                earthRef.current.style.backgroundColor = "rgba(212, 219, 242, 0.5)";
            },
        };
    return (react_1.default.createElement("div", { className: "panda-i18n-switcher" },
        react_1.default.createElement("div", __assign({ ref: earthRef, style: {
                width: 24,
                height: 24,
                backgroundColor: "#d4dbf2",
                color: "#3758c4",
                fontSize: 14,
                borderRadius: 4,
                cursor: "pointer",
                display: "flex",
                verticalAlign: "middle",
                alignItems: "center",
                justifyContent: "center",
                padding: 0,
            }, onMouseOut: function () {
                earthRef.current.style.backgroundColor = "#d4dbf2";
            }, className: "display" }, eventProps), currentLocale.alias),
        visible &&
            menuPos &&
            (0, react_dom_1.createPortal)(react_1.default.createElement(react_1.default.Fragment, null, renderOptions({
                type: "locale",
                ref: earthRef,
                dataSource: usedLocaleList,
            })), document.body)));
};
exports.GlobalizationComponent = GlobalizationComponent;
exports.default = exports.GlobalizationComponent;
